import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Controller} from "react-hook-form";
import FieldWithValidation from "../../../generic/fields/FieldWithValidation";
import {Input} from "reactstrap";
import {useDefaultEndpoints} from "../../../../lib/api/useDefaultEndpoints";
import {requiredRule} from "../rules";
import {t} from "i18next";

PublicContracts.propTypes = {
    form: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
};

function PublicContracts({form, state, setState, isRequired = true}) {
    const {control, errors} = form;
    const getPublicContracts = useDefaultEndpoints('public-contracts').getEntries;
    const [publicContracts, setPublicContracts] = useState([]);
    useEffect(() => {
        getPublicContracts({}).then(res => setPublicContracts(() => res));
    }, [])
    return (
        <Controller
            control={control}
            name="public_contract_url"
            defaultValue={state.public_contract_url || ''}
            rules={isRequired ? requiredRule : {}}
            render={(
                {value, onBlur, name, ref, onChange},
                {invalid}
            ) =>
                <FieldWithValidation invalid={invalid} errors={errors} label={t('common.forms.publicContracts.label')}
                                     name={name} isRequired={true}
                >
                    <Input  type="select" id={name} invalid={invalid} name={name} onBlur={onBlur}
                            style={{border: invalid ? '1px solid #dc3545' : '0'}}
                            value={value}
                            onChange={e => {
                                setState(e)
                                onChange(e.target.value)
                            }}>
                        <option value={t('common.forms.publicContracts.pickContract')} disabled></option>
                        {publicContracts.map(publicContract => <option value={publicContract.link} key={publicContract.id}>
                            {publicContract.tag}
                        </option>)}
                    </Input>
                </FieldWithValidation>
            }
        />
    );
}

export default PublicContracts;